module.exports = __webpack_public_path__ + "a0567c207509c40da904bf85fa53dd97.jpg";